<div class="Customers customers-summary ui-g-12">

  <div class="ui-g">
    <h1 class="step-title">{{ 'customers.overview' | translate }}</h1>
  </div>

  <div class="ui-g">
    <kv-search-toolbar
      [dateBoxEnabled]="false"
      [customersBoxEnabled]="false"
      [clusterFieldEnabled]="false"
      [date_structure]="searchModel.date_structure"
      [card_modes]="searchModel.card_modes"
      [clusters]="searchModel.cluster_list"
      [group_types]="searchModel.group_types"
      [groups]="searchModel.groups"
      [areas]="searchModel.areas"
      [stores]="searchModel.stores"
      [disableMutualExclusivity]="false"
      appQFilter
      (onQFilter)="searchValueTrend($event)"
    ></kv-search-toolbar>
  </div>

  <div class="ui-g">
    <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
      <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [t]="indicator.t" [options]="indicator.options"></app-infobox>
    </div>
  </div>

  <div class="campaigncharts" *ngIf="filterApplied">
    <div class="ui-g">
      <div class="ui-g-12 ui-md-6 ui-sm-12">
        <h2>{{ translations.customers_loyalty_trend }}</h2>
        <div class="chart-container">
          <chart [options]="customersLoyaltyTrend.options"
                 (load)="setChartInstance(customersLoyaltyTrend, $event.context)"></chart>
        </div>
      </div>

      <div class="ui-g-12 ui-md-6 ui-sm-12">
        <h2>{{ translations.new_customers }}</h2>
        <div class="chart-container">
          <chart [options]="newCustomersChart.options"
                 (load)="setChartInstance(newCustomersChart, $event.context)"></chart>
        </div>
      </div>
    </div>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers-summary/customers-summary.component.html